
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/artist",
      function () {
        return require("private-next-pages/artist/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/artist"])
      });
    }
  